"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBar = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const react_spring_1 = require("react-spring");
const chevron_button_1 = require("./chevron-button");
const StyledTabBarWrapper = components_core_1.styled.div `
  display: flex;
  align-items: flex-end;
  width: 100%;
  box-shadow: inset 0 -1px 0 ${props => props.theme.colors.border.divider};
`;
const StyledSliderContainer = components_core_1.styled.div `
  touch-action: none;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;

  display: ${props => props.totalColumnCount <= props.visibleColumnCount ? 'flex' : 'grid'};

  grid-template-columns: ${props => `repeat(${props.totalColumnCount}, ${(1 / props.visibleColumnCount) *
    100}%)`};

  ${props => props.totalColumnCount <= props.visibleColumnCount &&
    'justify-content: space-around;'}

  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    justify-content: ${props => props.totalColumnCount === props.visibleColumnCount &&
    props.visibleColumnCount >= 3
    ? 'space-between'
    : props.totalColumnCount < props.visibleColumnCount
        ? 'flex-start'
        : 'unset'};
  }
`;
const StyledChildWrapper = (0, components_core_1.styled)(react_spring_1.animated.div) `
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  white-space: normal;
  padding: 0 ${props => props.theme.size.static250};
  will-change: transform;
`;
const StyledPaginationWrapper = components_core_1.styled.div `
  grid-area: pagination;
  text-align: center;
`;
const StyledSliderWrapper = components_core_1.styled.div `
  grid-area: slider;
  display: flex;
  align-items: center;
`;
const ContentWrapper = components_core_1.styled.div `
  ${props => (0, components_core_1.css) `
    width: 100%;
    display: grid;
    ${props.withPagination
    ? "grid-template-areas: 'pagination' 'slider';"
    : "grid-template-areas:'slider';"}
    overflow: hidden;
    grid-template-columns: 100%;
  `}
`;
function getSlideTransformStyle(x) {
    return `translate3d(${x * -1}px,0,0)`;
}
const PaginationButton = (0, components_core_1.styled)(chevron_button_1.ChevronButton) `
  margin-bottom: ${props => props.theme.size.static150};
`;
function TabBar({ children, slider, visibleTabCount = 1, sliderElementRef, showPaginationNumber, prevButtonAriaLabel, nextButtonAriaLabel }) {
    const tabs = react_1.default.Children.toArray(children);
    const totalTabCount = tabs.length;
    const showPaginationButtons = totalTabCount > visibleTabCount;
    const { pageIndex, pageCount, springs, bindGestureHandlers, previous, next } = slider;
    return (react_1.default.createElement(StyledTabBarWrapper, { className: "tab-bar-wrapper" },
        showPaginationButtons && (react_1.default.createElement(PaginationButton, { orientation: "left", onClick: previous, disabled: pageIndex === 0, ariaLabel: prevButtonAriaLabel })),
        react_1.default.createElement(ContentWrapper, { withPagination: showPaginationNumber, className: "content-wrapper" },
            showPaginationButtons && showPaginationNumber ? (react_1.default.createElement(StyledPaginationWrapper, Object.assign({}, bindGestureHandlers(), { className: "pagination-wrapper" }),
                react_1.default.createElement(components_core_1.Text, { appearance: components_core_1.TokenTextAppearance.copy200, color: components_core_1.TokenTextColor.secondary },
                    slider.pageIndex + 1,
                    "/",
                    Math.ceil(totalTabCount / visibleTabCount)))) : (undefined),
            react_1.default.createElement(StyledSliderWrapper, { className: "slider-wrapper" },
                react_1.default.createElement(StyledSliderContainer, { ref: sliderElementRef, totalColumnCount: totalTabCount, visibleColumnCount: visibleTabCount, className: "slider-container" }, springs.map(({ x }, index) => (react_1.default.createElement(StyledChildWrapper, Object.assign({}, bindGestureHandlers(), { key: index, style: { transform: x.interpolate(getSlideTransformStyle) }, className: "slider-spring-wrapper" }), tabs[index])))))),
        showPaginationButtons && (react_1.default.createElement(PaginationButton, { orientation: "right", onClick: next, disabled: pageIndex === pageCount - 1, testId: "rightPaginationButton", ariaLabel: nextButtonAriaLabel }))));
}
exports.TabBar = TabBar;
